'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PersonModel = require('../model/PersonModel');

var _PersonModel2 = _interopRequireDefault(_PersonModel);

var _PersonGenderOptions = require('../constants/PersonGenderOptions');

var _PersonGenderOptions2 = _interopRequireDefault(_PersonGenderOptions);

var _PersonMaritalStatusOptions = require('../constants/PersonMaritalStatusOptions');

var _PersonMaritalStatusOptions2 = _interopRequireDefault(_PersonMaritalStatusOptions);

var _CountryOptions = require('../../constants/CountryOptions');

var _CountryOptions2 = _interopRequireDefault(_CountryOptions);

var _ImageSelectControl = require('../../../lib/ui/ImageSelectControl');

var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _SelectControl = require('../../../lib/ui/SelectControl');

var _SelectControl2 = _interopRequireDefault(_SelectControl);

var _DateControl = require('../../../lib/ui/DateControl');

var _DateControl2 = _interopRequireDefault(_DateControl);

var _StaticControl = require('../../../lib/ui/StaticControl');

var _StaticControl2 = _interopRequireDefault(_StaticControl);

var _PhonenumberControl = require('../../../lib/ui/PhonenumberControl');

var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);

var _EmailControl = require('../../../lib/ui/EmailControl');

var _EmailControl2 = _interopRequireDefault(_EmailControl);

var _LinkedinControl = require('../../../lib/ui/LinkedinControl');

var _LinkedinControl2 = _interopRequireDefault(_LinkedinControl);

var _FacebookControl = require('../../../lib/ui/FacebookControl');

var _FacebookControl2 = _interopRequireDefault(_FacebookControl);

var _SkypeControl = require('../../../lib/ui/SkypeControl');

var _SkypeControl2 = _interopRequireDefault(_SkypeControl);

var _TwitterControl = require('../../../lib/ui/TwitterControl');

var _TwitterControl2 = _interopRequireDefault(_TwitterControl);

var _CheckboxControl = require('../../../lib/ui/CheckboxControl');

var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);

var _GoogleMapsButtonControl = require('../../../lib/ui/GoogleMapsButtonControl');

var _GoogleMapsButtonControl2 = _interopRequireDefault(_GoogleMapsButtonControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PersonForm = function () {
    function PersonForm(element, args) {
        var _this = this;

        _classCallCheck(this, PersonForm);

        var fieldsetPersonal = document.createElement('fieldset');
        var legendPersonal = document.createElement('legend');
        legendPersonal.innerHTML = 'Persoonsgegevens';
        fieldsetPersonal.appendChild(legendPersonal);

        this.id = args.person.values.id;
        this.image = new _ImageSelectControl2.default(fieldsetPersonal, { label: 'Afbeelding', value: args.person.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.lastname = new _TextControl2.default(fieldsetPersonal, { label: 'Achternaam', value: args.person.values.lastname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.suffix = new _TextControl2.default(fieldsetPersonal, { label: 'Tussenvoegsels', value: args.person.values.suffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.maidenname = new _TextControl2.default(fieldsetPersonal, { label: 'Meisjesnaam', value: args.person.values.maidenname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.maidensuffix = new _TextControl2.default(fieldsetPersonal, { label: 'Meisjestussenvoegsels', value: args.person.values.maidensuffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.forenames = new _TextControl2.default(fieldsetPersonal, { label: 'Voornamen', value: args.person.values.forenames, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.initials = new _TextControl2.default(fieldsetPersonal, { label: 'Voorletters', value: args.person.values.initials, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.nickname = new _TextControl2.default(fieldsetPersonal, { label: 'Roepnaam', value: args.person.values.nickname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.gender = new _SelectControl2.default(fieldsetPersonal, { label: 'Geslacht', value: args.person.values.gender, options: _PersonGenderOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });

        var fieldsetBackground = document.createElement('fieldset');
        var legendBackground = document.createElement('legend');
        legendBackground.innerHTML = 'Achtergrond gegevens';
        fieldsetBackground.appendChild(legendBackground);

        this.calculateAge = function () {
            if (!_this.dateofbirth.getValue()) {
                _this.age.setValue('Onbekend');
                return;
            }

            var beginDate = new Date(_this.dateofbirth.getValue());

            if (isNaN(beginDate)) {
                _this.age.setValue('Onbekend');
                return;
            }

            var endDate = new Date();

            if (_this.dateofdeath.getValue()) {
                endDate = new Date(_this.dateofdeath.getValue());
                if (isNaN(endDate)) {
                    endDate = new Date();
                }
            }

            var calculatedAge = endDate.getFullYear() - beginDate.getFullYear();

            var month = endDate.getMonth() - beginDate.getMonth();
            if (month < 0 || month === 0 && endDate.getDate() < beginDate.getDate()) {
                calculatedAge--;
            }

            if (calculatedAge < 0) {
                calculatedAge = 0;
            }

            _this.age.setValue(calculatedAge);
        };

        this.nationality = new _SelectControl2.default(fieldsetBackground, { label: 'Nationaliteit', value: args.person.values.nationality, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.countryoforigin = new _SelectControl2.default(fieldsetBackground, { label: 'Land van herkomst', value: args.person.values.countryoforigin, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.religion = new _TextControl2.default(fieldsetBackground, { label: 'Etniciteit', value: args.person.values.religion, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.maritalstatus = new _SelectControl2.default(fieldsetBackground, { label: 'Burgelijke staat', value: args.person.values.maritalstatus, options: _PersonMaritalStatusOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.dateofbirth = new _DateControl2.default(fieldsetBackground, { label: 'Geboortedatum', value: args.person.values.dateofbirth, onchange: function onchange(e) {
                _this.calculateAge();
                if (args.onchange) {
                    args.onchange(e);
                }
            } });
        this.age = new _StaticControl2.default(fieldsetBackground, { label: 'Leeftijd', value: '-', readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.dateofdeath = new _DateControl2.default(fieldsetBackground, { label: 'Sterfdatum', value: args.person.values.dateofdeath, onchange: function onchange(e) {
                _this.calculateAge();
                if (args.onchange) {
                    args.onchange(e);
                }
            } });

        var fieldsetAddress = document.createElement('fieldset');
        var legendAddress = document.createElement('legend');
        legendAddress.innerHTML = 'Woonadres';
        fieldsetAddress.appendChild(legendAddress);

        this.address = new _TextControl2.default(fieldsetAddress, { label: 'Adres', value: args.person.values.address, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.zipcode = new _TextControl2.default(fieldsetAddress, { label: 'Postcode', value: args.person.values.zipcode, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.city = new _TextControl2.default(fieldsetAddress, { label: 'Plaats', value: args.person.values.city, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.region = new _TextControl2.default(fieldsetAddress, { label: 'Provincie', value: args.person.values.region, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.country = new _SelectControl2.default(fieldsetAddress, { label: 'Land', value: args.person.values.country, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.addressGoogleMaps = new _GoogleMapsButtonControl2.default(fieldsetAddress, { getValues: function getValues() {
                return [_this.address.getValue(), _this.zipcode.getValue(), _this.city.getValue(), _this.region.getValue(), _this.country.getValue()];
            } });

        var fieldsetContact = document.createElement('fieldset');
        var legendContact = document.createElement('legend');
        legendContact.innerHTML = 'Contact gegevens';
        fieldsetContact.appendChild(legendContact);

        this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.person.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.mobile = new _PhonenumberControl2.default(fieldsetContact, { label: 'Mobiel', value: args.person.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.person.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.linkedinid = new _LinkedinControl2.default(fieldsetContact, { label: 'LinkedIn ID', value: args.person.values.linkedinid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.twitterid = new _TwitterControl2.default(fieldsetContact, { label: 'Twitter ID', value: args.person.values.twitterid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.facebookid = new _FacebookControl2.default(fieldsetContact, { label: 'Facebook ID', value: args.person.values.facebookid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.skypeid = new _SkypeControl2.default(fieldsetContact, { label: 'Skype ID', value: args.person.values.skypeid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });

        var fieldsetOptions = document.createElement('fieldset');
        var legendOptions = document.createElement('legend');
        legendOptions.innerHTML = 'Opties';
        fieldsetOptions.appendChild(legendOptions);

        this.sendbirthdayemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per e-mail', value: args.person.values.sendbirthdayemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.sendbirthdaycard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per post', value: args.person.values.sendbirthdaycard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', value: args.person.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
        this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', value: args.person.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });

        var fragment = document.createDocumentFragment();
        fragment.appendChild(fieldsetPersonal);
        fragment.appendChild(fieldsetBackground);
        fragment.appendChild(fieldsetAddress);
        fragment.appendChild(fieldsetContact);
        fragment.appendChild(fieldsetOptions);

        this.calculateAge();

        element.appendChild(fragment);
    }

    _createClass(PersonForm, [{
        key: 'getValue',
        value: function getValue() {
            var person = new _PersonModel2.default();
            person.values.id = this.id;
            person.values.image = this.image.getValue();
            person.values.lastname = this.lastname.getValue();
            person.values.suffix = this.suffix.getValue();
            person.values.maidenname = this.maidenname.getValue();
            person.values.maidensuffix = this.maidensuffix.getValue();
            person.values.forenames = this.forenames.getValue();
            person.values.initials = this.initials.getValue();
            person.values.nickname = this.nickname.getValue();
            person.values.gender = this.gender.getValue();
            person.values.nationality = this.nationality.getValue();
            person.values.countryoforigin = this.countryoforigin.getValue();
            person.values.religion = this.religion.getValue();
            person.values.maritalstatus = this.maritalstatus.getValue();
            person.values.dateofbirth = this.dateofbirth.getValue();
            person.values.dateofdeath = this.dateofdeath.getValue();
            person.values.address = this.address.getValue();
            person.values.zipcode = this.zipcode.getValue();
            person.values.city = this.city.getValue();
            person.values.region = this.region.getValue();
            person.values.country = this.country.getValue();
            person.values.phone = this.phone.getValue();
            person.values.mobile = this.mobile.getValue();
            person.values.email = this.email.getValue();
            person.values.linkedinid = this.linkedinid.getValue();
            person.values.twitterid = this.twitterid.getValue();
            person.values.facebookid = this.facebookid.getValue();
            person.values.skypeid = this.skypeid.getValue();
            person.values.sendbirthdayemail = this.sendbirthdayemail.getValue();
            person.values.sendbirthdaycard = this.sendbirthdaycard.getValue();
            person.values.sendchristmasemail = this.sendchristmasemail.getValue();
            person.values.sendchristmascard = this.sendchristmascard.getValue();
            return person;
        }
    }, {
        key: 'setValue',
        value: function setValue(person) {
            this.id = person.values.id;
            this.image.setValue(person.values.image);
            this.lastname.setValue(person.values.lastname);
            this.suffix.setValue(person.values.suffix);
            this.maidenname.setValue(person.values.maidenname);
            this.maidensuffix.setValue(person.values.maidensuffix);
            this.forenames.setValue(person.values.forenames);
            this.initials.setValue(person.values.initials);
            this.nickname.setValue(person.values.nickname);
            this.gender.setValue(person.values.gender);
            this.nationality.setValue(person.values.nationality);
            this.countryoforigin.setValue(person.values.countryoforigin);
            this.religion.setValue(person.values.religion);
            this.maritalstatus.setValue(person.values.maritalstatus);
            this.dateofbirth.setValue(person.values.dateofbirth);
            this.dateofdeath.setValue(person.values.dateofdeath);
            this.address.setValue(person.values.address);
            this.zipcode.setValue(person.values.zipcode);
            this.city.setValue(person.values.city);
            this.region.setValue(person.values.region);
            this.country.setValue(person.values.country);
            this.phone.setValue(person.values.phone);
            this.mobile.setValue(person.values.mobile);
            this.email.setValue(person.values.email);
            this.linkedinid.setValue(person.values.linkedinid);
            this.twitterid.setValue(person.values.twitterid);
            this.facebookid.setValue(person.values.facebookid);
            this.skypeid.setValue(person.values.skypeid);
            this.sendbirthdayemail.setValue(person.values.sendbirthdayemail);
            this.sendbirthdaycard.setValue(person.values.sendbirthdaycard);
            this.sendchristmasemail.setValue(person.values.sendchristmasemail);
            this.sendchristmascard.setValue(person.values.sendchristmascard);

            this.calculateAge();
        }
    }]);

    return PersonForm;
}();

exports.default = PersonForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/ui/PersonForm.js
// module id = 33
// module chunks = 0